import { Form, Modal } from 'antd';
import { memo, useEffect, useRef, useState } from 'react';
import { Subscription } from 'rxjs';
import BaseModalAction from 'src/libraries/BaseModalAction';
import { BaseInput } from 'src/libraries/form/BaseInput';
import UserService from 'src/services/user.service';
import EventBus from 'src/utils/event-bus/event-bus';
import { EventBusName, IBaseEventPayload } from 'src/utils/event-bus/event-bus.types';
import MESSAGE from 'src/utils/message';

function ModalChangePassword() {
  const [open, setOpen] = useState<boolean>(false);
  const subscriptions = useRef<any>();
  const sv = new UserService();
  const [form] = Form.useForm<any>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    registerEventBus();

    return () => {
      unregisterEventBus();
    };
  }, []);

  const registerEventBus = () => {
    subscriptions.current = new Subscription();
    subscriptions.current.add(
      EventBus.getInstance().events.subscribe((data: IBaseEventPayload<any>) => {
        data.type === EventBusName.SHOW_MODAL_CHANGE_PASSWORD && setOpen(true);
      }),
    );
  };

  const unregisterEventBus = () => {
    subscriptions.current?.unsubscribe();
  };

  const onCancel = () => {
    setOpen(false);
  };

  const onFinish = async (values: any) => {
    if (loading) return;
    setLoading(true);
    try {
      await sv.changePassword({
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      });
      MESSAGE.success('Thay đổi mật khẩu thành công!');
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <Modal onCancel={onCancel} width="30vw" open={open} footer={null} title="Đổi mật khẩu" maskClosable={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <BaseInput
          name="oldPassword"
          span={24}
          label="Mật khẩu hiện tại"
          required
          rule={{ required: true, isPassword: true }}
        />
        <BaseInput name="newPassword" span={24} label="Mật khẩu mới" rule={{ required: true, isPassword: true }} />
        <BaseInput
          name="reNewPassword"
          rules={[
            ({ getFieldValue }: any) => ({
              validator(_: any, value: any) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Mật khẩu không trùng khớp!'));
              },
            }),
          ]}
          span={24}
          label="Nhập lại mật khẩu"
          rule={{ required: true, isPassword: true }}
        />
        <BaseModalAction onCancel={onCancel} loading={loading} />
      </Form>
    </Modal>
  );
}

export default memo(ModalChangePassword);
